import { Link } from 'react-router-dom';

interface ButtonCTAProps {
  children?: string;
  href?: string;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'link';
}

export default function ButtonCTA({ children = 'Devis gratuit', href, onClick, type = 'link' }: ButtonCTAProps) {
  const baseClasses = 'inline-flex items-center justify-center whitespace-nowrap px-8 py-3.5 rounded-lg font-semibold text-base transition-all duration-200 bg-accent-500 text-white hover:bg-accent-600 cursor-pointer';

  if (type === 'button' || type === 'submit') {
    return (
      <button type={type} onClick={onClick} className={baseClasses}>
        {children}
      </button>
    );
  }

  if (href) {
    return (
      <Link to={href} className={baseClasses}>
        {children}
      </Link>
    );
  }

  return (
    <button type="button" onClick={onClick} className={baseClasses}>
      {children}
    </button>
  );
}